<template>
  <div class="PageMyReleaseOrder">
    <h2 class="includeBtn">{{ $t("pages.wording.releaseOrder") }}</h2>
    <!--我的放行單-->
    <div class="releaseOrderTopBox">
      <div class="releaseOrder releaseOrderTopText">
        {{ $t("pages.wording.releaseNo") }}:{{ ruleForm.releaseOrderNo }}
      </div>
      <!--releaseOrder-->
      <div class="releaseOrderTopText">
        {{ $t("pages.wording.reserve") }}:
        <a class="reserveOrderTitle" @click="goReserveInfoPage()">{{ titleReserveNo }}</a>
      </div>
      <!--reserveOrder-->
      <div class="Btn-Bottom-Content">
        <div class="Btn-Content">
          <el-button v-if="roleNotYetSign" class="button-right" @click="applyReviewResult()" type="warning">{{
            $t("pages.button.exam")
          }}</el-button>
          <el-button class="button-right" @click="goBack()" type="success">{{ $t("pages.button.close") }}</el-button>
        </div>
      </div>
      <!--Btn-Bottom-Content-->
    </div>
    <!--releaseOrderTopBox-->
    <el-collapse v-model="activeShowBlock">
      <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="120px">
        <el-collapse-item class="collapsecontent" name="basic">
          <template slot="title">
            <h3>{{ $t("pages.wording.basisInfo") }}</h3>
            <!--基本資訊-->
          </template>
          <div class="boxContain c-form">
            <!--查詢放行單-->
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.applicatorName')" prop="applicatorName"
                  ><!--填單人-->
                  <el-input
                    :disabled="true"
                    v-model="ruleForm.applicatorName"
                    :placeholder="$t('pages.wording.placeholderNodata')"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.deltaContactName')" prop="deltaContactName"
                  ><!--台達接洽人-->
                  <el-input
                    :disabled="true"
                    v-model="ruleForm.deltaContactName"
                    :placeholder="$t('pages.wording.placeholderNodata')"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.deltaContactNumber')" prop="deltaContactNumber"
                  ><!--接洽人電話-->
                  <el-input
                    :disabled="true"
                    v-model="ruleForm.deltaContactNumber"
                    :placeholder="$t('pages.wording.placeholderNodata')"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.deltaContactMail')" prop="deltaContactMail"
                  ><!--接洽人Mail-->
                  <el-input
                    :disabled="true"
                    v-model="ruleForm.deltaContactMail"
                    :placeholder="$t('pages.wording.placeholderNodata')"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <!--boxContain-->
        </el-collapse-item>
        <el-collapse-item class="collapsecontent" name="detail">
          <template slot="title">
            <h3>{{ $t("pages.wording.detailInfo") }}</h3>
            <!--詳細資訊-->
          </template>
          <div class="boxContain c-form">
            <!--查詢放行單-->
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="OA Code" prop="oaCode"
                  ><!--OA Code-->
                  <el-input
                    :disabled="true"
                    v-model="ruleForm.oaCode"
                    :placeholder="$t('pages.wording.placeholderNodata')"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.vendor')" prop="vendor"
                  ><!--公司名稱-->
                  <el-input
                    :disabled="true"
                    v-model="ruleForm.vendor"
                    :placeholder="$t('pages.wording.placeholderNodata')"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.reserveArriveDate')" prop="reserveArriveDate"
                  ><!--預約抵達日期-->
                  <el-input
                    :disabled="true"
                    v-model="ruleForm.reserveArriveDate"
                    :placeholder="$t('pages.wording.placeholderNodata')"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.reserveArriveTime')" prop="reserveArriveTime"
                  ><!--預約抵達時間-->
                  <el-input
                    :disabled="true"
                    v-model="ruleForm.reserveArriveTime"
                    :placeholder="$t('pages.wording.placeholderNodata')"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.carPlat')" prop="carPlat"
                  ><!--車輛號牌-->
                  <el-input
                    :disabled="true"
                    v-model="ruleForm.carPlat"
                    :placeholder="$t('pages.wording.placeholderNodata')"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.salesDate')" prop="saleDate"
                  ><!--出售日期-->
                  <el-input
                    :disabled="true"
                    v-model="ruleForm.reserveArriveDate"
                    :placeholder="$t('pages.wording.placeholderNodata')"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.reserveFactory')" prop="reserveFactory"
                  ><!--抵達廠別-->
                  <el-input
                    :disabled="true"
                    v-model="ruleForm.reserveFactory"
                    :placeholder="$t('pages.wording.placeholderNodata')"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.reserveLocation')" prop="reserveLocation"
                  ><!--抵達地點-->
                  <el-input
                    :disabled="true"
                    v-model="ruleForm.reserveLocation"
                    :placeholder="$t('pages.wording.placeholderNodata')"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.emptyCar')" prop="emptyCarWeight"
                  ><!--空車重量-->
                  <el-input
                    :disabled="true"
                    type="number"
                    v-model="ruleForm.emptyCarWeight"
                    :rules="rules.emptyCarWeight"
                    :placeholder="$t('pages.wording.placeholderInput')"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.scaleLocation')" prop="scaleLocation"
                  ><!--過磅地點-->
                  <el-input
                    :disabled="true"
                    v-model="ruleForm.scaleLocation"
                    :rules="rules.emptyCarWeight"
                    :placeholder="$t('pages.wording.placeholderInput')"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <!--boxContain-->
        </el-collapse-item>
      </el-form>
      <el-form ref="soRuleForm" :model="soRuleForm" :rules="rules" label-width="0px">
        <el-collapse-item class="collapsecontent" name="materialDetial">
          <template slot="title">
            <h3>{{ $t("pages.wording.materialDetial") }}</h3>
            <!--廢料明細資訊-->
          </template>
          <div class="boxContain c-table includeBtn">
            <el-tabs v-model="activeName">
              <el-tab-pane label="preProcess" name="first">
                <span slot="label"><i class="el-icon-takeaway-box"></i>{{ $t("pages.wording.materialInfo") }}</span
                ><!--廢料明細-->
                <div class="s-table">
                  <template>
                    <el-table :data="soRuleForm.soList" class="soList" border style="width: 100%" height="450px">
                      <el-table-column prop="SO" label="SO" width="80"></el-table-column
                      ><!--SO--><!--so-->
                      <el-table-column prop="SOLine" label="SO LINE" width="80"></el-table-column
                      ><!--SO LINE--><!--soLine-->
                      <el-table-column prop="partNo" :label="$t('pages.wording.partNo')" width="120"></el-table-column
                      ><!--廢料料號--><!--partNo-->
                      <el-table-column :label="$t('pages.wording.partName')" width="120">
                        <template slot-scope="scope">
                          {{ displayPartName(getLanguage(), scope.row.partNameCN, scope.row.partName) }}
                        </template> </el-table-column
                      ><!--廢料名稱--><!--partName-->
                      <el-table-column :label="$t('pages.wording.grossWeight')" width="120">
                        <template slot-scope="scope">
                          <el-form-item :prop="'soList.' + scope.$index + '.grossWeight'" :rules="rules.grossWeight">
                            <el-input :disabled="true" v-model="scope.row.grossWeight" type="number" />
                          </el-form-item>
                        </template> </el-table-column
                      ><!--毛重--><!--grossWeight-->
                      <el-table-column :label="$t('pages.wording.packType')" width="120">
                        <template slot-scope="scope">
                          <el-form-item :prop="'soList.' + scope.$index + '.packType'" :rules="rules.packType">
                            <el-input :disabled="true" v-model="scope.row.packType" />
                          </el-form-item>
                        </template> </el-table-column
                      ><!--包裝種類--><!--packType-->
                      <el-table-column :label="$t('pages.wording.packNumber')" width="120">
                        <template slot-scope="scope">
                          <el-form-item :prop="'soList.' + scope.$index + '.packNumber'" :rules="rules.packNumber">
                            <el-input :disabled="true" type="number" v-model="scope.row.packNumber" />
                          </el-form-item>
                        </template> </el-table-column
                      ><!--包裝數量--><!--packNumber-->
                      <el-table-column :label="$t('pages.wording.packWeight')" width="120">
                        <template slot-scope="scope">
                          <el-form-item :prop="'soList.' + scope.$index + '.packWeight'" :rules="rules.packWeight">
                            <el-input type="number" v-model="scope.row.packWeight" />
                          </el-form-item>
                        </template> </el-table-column
                      ><!--總皮重--><!--packWeight-->
                      <el-table-column prop="netWeight" :label="$t('pages.wording.netWeight')" width="120">
                      </el-table-column
                      ><!--淨重--><!--netWeight-->
                      <el-table-column prop="unit" :label="$t('pages.wording.unit')" width="120"></el-table-column
                      ><!--單位--><!--unit-->
                      <el-table-column prop="plantCode" label="Plant Code" width="120"></el-table-column
                      ><!--PlantCode--><!--plantCode-->
                      <el-table-column prop="storageLogic" label="Storage Loc." width="120"></el-table-column
                      ><!--PlantCode--><!--storageLogic-->
                    </el-table>
                  </template>
                </div>
                <!--s-table--> </el-tab-pane
              ><!--preProcess-->
            </el-tabs>
          </div>
          <!--boxContain-->
        </el-collapse-item>
      </el-form>
      <el-collapse-item class="collapsecontent" name="signDetail">
        <template slot="title">
          <h3>{{ $t("pages.wording.signProcess") }}</h3>
          <!--詳細資訊-->
        </template>
        <el-table class="dialogSoCredit" :data="signTable" border style="width: 100%" height="300px">
          <el-table-column prop="signRole" :label="$t('pages.wording.role')" width="">
            <template slot-scope="scope">
              {{ $t("role." + scope.row.signRole) }}
            </template> </el-table-column
          ><!--角色-->
          <el-table-column prop="signUserName" :label="$t('pages.wording.signUserName')" width=""> </el-table-column
          ><!--簽核者-->
          <el-table-column prop="signUserID" :label="$t('pages.wording.signUserID')" width="120"> </el-table-column
          ><!--工號-->
          <el-table-column prop="date" :label="$t('pages.wording.ExamDate')" width="">
            <template slot-scope="scope">
              {{ scope.row.signDate }} {{ scope.row.signTime }}
            </template> </el-table-column
          ><!--簽核日期時間-->
        </el-table>
      </el-collapse-item>
    </el-collapse>
  </div>
  <!--PageMyReleaseOrder-->
</template>

<script>
import { api } from "@/utils/api.js"
import { utils } from "@/utils/utils.js"
import { role } from "@/config/role.js"
import { mapGetters } from "vuex"
export default {
  name: "PageMyApprovalReleaseFormDesktop",
  components: {},
  props: {
    releaseID: {
      type: Number,
      default: () => -1,
    },
    prvPageInfo: {
      type: Object,
    },
  },
  data() {
    return {
      readOnly: false,
      activeName: "first",
      submitData: {},
      releaseData: {},
      reserveData: {},
      titleReserveNo: "",
      soList: [],
      signTable: [],
      roleNotYetSign: false,
      showBackPrvButton: false,
      applicator: {
        name: "",
        number: "",
        deptName: "",
        area: "",
        deptCode: "",
      },
      optionItem: {
        scaleLocation: [
          { lable: "廠內", value: "廠內" },
          { lable: "廠外", value: "廠外" },
        ],
        packType: [
          { label: "無", value: "無" },
          { label: "噸袋", value: "噸袋" },
          { label: "小袋子", value: "小袋子" },
          { label: "木框", value: "木框" },
          { label: "桶", value: "桶" },
          { label: "棧板+紙皮", value: "棧板+紙皮" },
          { label: "棧板+桶", value: "棧板+桶" },
          { label: "棧板+噸袋", value: "棧板+噸袋" },
          { label: "棧板", value: "棧板" },
          { label: "棧板（自帶）", value: "棧板（自帶）" },
        ],
      },
      ruleForm: {
        //基本資訊
        releaseOrderNo: "",
        reserveNo: "",
        applicatorName: "", //申請人
        applicatorNT: "",
        deltaContactName: "", //台達接洽人
        deltaContactNumber: "", //台達接洽人電話
        deltaContactMail: "", //台達接洽人Mail
        //詳細資訊
        oaCode: "",
        vendor: "", //廠商名稱
        reserveArriveDate: "", //進廠日期
        reserveArriveTime: "", //進廠時間
        carPlat: "", //車牌
        saleDate: "", //出售日期
        reserveFactory: "", //抵達廠別
        reserveLocation: "", //抵達地點
        emptyCarWeight: "", //空車重量
        scaleLocation: "", //過磅地點
        //others
        soCreditStatus: false,
      },
      soRuleForm: {
        soList: [],
      },
      rules: {
        emptyCarWeight: [{ required: true, message: this.$t("pages.wording.requiredInput"), trigger: "blur" }],
        grossWeight: [{ required: true, message: this.$t("pages.wording.requiredInput"), trigger: "blur" }],
        packType: [{ required: true, message: this.$t("pages.wording.requiredInput"), trigger: "blur" }],
        scaleLocation: [{ required: true, message: this.$t("pages.wording.requiredInput"), trigger: "blur" }],
        packNumber: [{ required: true, message: this.$t("pages.wording.requiredInput"), trigger: "blur" }],
      },
      activeShowBlock: ["basic", "detail", "materialDetial", "signDetail"],
    }
  },
  created() {
    this.init()
  },
  methods: {
    ...mapGetters(["getUserProfile", "getUserRoles", "getLanguage"]),
    init() {
      let vueInstance = this
      if (vueInstance.prvPageInfo !== undefined && vueInstance.prvPageInfo !== null) {
        vueInstance.showBackPrvButton = true
      }
      let userRoles = vueInstance.getUserRoles()
      if (userRoles.length === 1 && userRoles.includes(role.GUARD_LEAD)) {
        vueInstance.readOnly = true
      }
      vueInstance.getSignTable(vueInstance.releaseID)
      vueInstance.getReleaseInfo(vueInstance.releaseID)
    },
    getReleaseInfo(id) {
      let paramter = { releaseId: id }
      this.$store.dispatch("getReleaseInfo", { params: paramter })
    },
    getSignTable(id) {
      let vueInstance = this
      let params = { releaseId: id }
      api
        .apiGetSignTable(params)
        .then((response) => {
          if (response.data.success) {
            vueInstance.signTable = response.data.result
            vueInstance.signTable.forEach((item) => {
              if (item.signUserID === null) {
                if (vueInstance.getUserRoles().includes(item.signRole)) {
                  vueInstance.roleNotYetSign = true
                  return
                }
              }
            })
          }
        })
        .catch(function (e) {
          console.log(e)
        })
    },
    displayPartName(lang, chName, enName) {
      return utils.displayPartName(utils.displayCHName(lang), chName, enName)
    },
    applyReviewResult() {
      let vueInstance = this
      let params = {
        releaseID: vueInstance.releaseID,
      }
      utils.showLoading(vueInstance)
      api
        .apiApprovalRelease(params)
        .then((response) => {
          utils.closeLoading(vueInstance)
          if (response.data.success) {
            vueInstance.$alert(vueInstance.$t("message.alert.successReview"), vueInstance.$t("message.title.success"), {
              confirmButtonText: vueInstance.$t("pages.button.confirm"),
              callback: () => {
                vueInstance.$router.push({
                  name: "PageMyApprovalRelease",
                })
              },
            })
          }
        })
        .catch(function (e) {
          utils.closeLoading(vueInstance)
          console.log(e)
        })
    },
    buildReleaseInfo(data) {
      this.ruleForm.saleDate = data.saleDate
      this.ruleForm.emptyCarWeight = data.emptyCarWeight
      this.ruleForm.scaleLocation = data.scaleLocation
      this.ruleForm.releaseOrderNo = data.releaseOrderNo
    },
    buildReserveInfo(data) {
      this.ruleForm.reserveNo = data.reserveNo
      this.titleReserveNo =
        this.ruleForm.reserveNo === utils.getDefaultReserveNo()
          ? this.$t("pages.wording.reserveNoIsDefault")
          : this.ruleForm.reserveNo
      this.ruleForm.applicatorName = data.applicatorName
      this.ruleForm.applicatorNT = data.applicatorNT
      this.ruleForm.deltaContactName = data.deltaContactName
      this.ruleForm.deltaContactNumber = data.deltaContactNumber
      this.ruleForm.deltaContactMail = data.deltaContactMail
      this.ruleForm.oaCode = data.OACode
      this.ruleForm.vendor = data.vendor
      this.ruleForm.reserveArriveDate = utils.getFormateDateTime("Date", data.reserveArriveDatetime)
      this.ruleForm.reserveArriveTime = utils.getFormateDateTime("Time", data.reserveArriveDatetime)
      if (data.tempCar) this.ruleForm.carPlat = data.tmpCarPlat
      else this.ruleForm.carPlat = data.carPlat
      this.ruleForm.reserveFactory = data.reserveFactory
      this.ruleForm.reserveLocation = data.reserveLocation
    },
    buildSoListInfo(datas) {
      this.soRuleForm.soList = datas
    },
    goReserveInfoPage() {
      let routeInfoData = this.$router.resolve({
        name: "PageMyApprovalReleaseReservationInfo",
        query: { id: this.reserveData.id },
      })
      window.open(routeInfoData.href, "_blank")
    },
    goBack() {
      let prevPageParams = window.sessionStorage.getItem("prevPageParams")
      window.sessionStorage.removeItem("prevPageParams")
      let prevPageObject = null
      if (prevPageParams !== null) {
        prevPageObject = JSON.parse(prevPageParams)
        switch (prevPageObject.routeName) {
          case "PageSearchReleaseOrder":
            this.setQueryParamsToStorage()
            break
        }
        this.$router.push({
          name: prevPageObject.routeName,
          params: prevPageObject.key,
        })
      }
    },
    setQueryParamsToStorage() {
      let tempQueryParams = window.sessionStorage.getItem("tempQueryParams")
      window.sessionStorage.removeItem("tempQueryParams")
      window.sessionStorage.setItem("queryParams", tempQueryParams)
    },
  },
  watch: {
    "$store.getters.alertMessage": function (val) {
      let code = val.code
      let message = val.message
      let cb = val.cb
      let title = code == 0 ? "success" : "fail"

      utils.alertMessage(this, code, message, title, cb)
    },
    "$store.getters.releaseInfo": function (val) {
      this.submitData = {
        releaseData: val.releseData,
        soList: val.soList,
      }
      //save as origion data
      this.releaseData = val.releseData
      this.reserveData = val.reserveData
      this.soList = val.soList

      //build page data
      this.buildReleaseInfo(this.releaseData)
      this.buildReserveInfo(this.reserveData)
      this.buildSoListInfo(this.soList)
    },
  },
}
</script>

<style>
.releaseOrderTopBox {
  position: relative;
  margin-bottom: 15px;
}
.releaseOrderTopBox .releaseOrderTopText {
  display: inline-block;
  font-size: 1.8rem;
  width: 50%;
}

.soList .el-form-item__content input {
  width: 100%;
  height: 30px;
}
.soList .el-form-item {
  margin-bottom: 0px;
}
.reserveOrderTitle {
  color: #007bff !important;
  cursor: pointer;
}
.reserveOrderTitle:hover {
  text-decoration: underline !important;
}
#app .dialogSoCredit {
  margin: 0px auto;
  border: 1px #ccc solid;
}
#app .dialogSoCredit th {
  background-color: #f5f5f5;
  font-weight: bolder;
}
#creditText {
  width: 90%;
  margin: 10px auto;
}
.soList table .is-error .el-input {
  margin-bottom: 12px;
}
.soList table .is-error .el-form-item__error {
  top: 70%;
}
</style>
<style scoped>
.Btn-Bottom-Content {
  position: fixed !important;
  background: rgb(22, 22, 21) !important;
  background: linear-gradient(
    0deg,
    rgba(22, 22, 21, 0.7931547619047619) 26%,
    rgba(255, 255, 255, 0.03125) 96%
  ) !important;
  z-index: 5 !important;
  height: 100px !important;
  bottom: 0px !important;
  left: 0px !important;
  right: 0px !important;
  overflow: hidden !important;
}
.Btn-Content {
  width: 93%;
}
.button-right {
  margin-left: 10px !important;
  margin-top: 5px !important;
}
.button-last {
  margin-left: 10px !important;
}
@media (max-width: 1025px) {
  .Btn-Bottom-Content {
    left: 0px !important;
  }
}
@media (min-width: 1026px) {
  .menuOpen .Btn-Bottom-Content {
    left: 299px !important;
  }
}
</style>
